import React from "react";
import './Clients.css';

type ManageableAccessProps = {
    scopeList: Array<string>
    previouslySelectedScopes: Array<string>
    onClose: () => void;
    onSave: (scopesToAdd: Array<string>, scopesToRemove: Array<string>) => void;
};

type ManageableAccessState = {
    newSelectedScopes: Array<string>
};

class ManageableAccess extends React.Component<ManageableAccessProps, ManageableAccessState> {
    constructor(props: ManageableAccessProps) {
        super(props);
        this.state = {
            newSelectedScopes: props.previouslySelectedScopes
        }
    }

    render() {
        return (
            <div className="ManageableAccess-overlay">
                <h3>Manage Access</h3>
                <ul className="ManageableAccess-list">
                    {this.props.scopeList.map((scope, idx) => (
                        <li key={idx} className="ManageableAccess-scope">
                            <input type="checkbox" id={scope} checked={this.state.newSelectedScopes.includes(scope)} onChange={(event) => this.toggleScope(scope, event.target.checked)}/>
                            <label htmlFor={scope}>{scope}</label>
                        </li>
                    ))}
                </ul>
                    <div className="ManageableAccess-actions">
                    <button onClick={this.handleSave}>Save</button>
                    <button onClick={this.props.onClose}>Cancel</button>
                </div>
            </div>
        );
    }

    private toggleScope(scope: string, selected: boolean) {
        if (selected) {
            this.setState({
                newSelectedScopes: this.state.newSelectedScopes.concat(scope)
            });
        } else {
            this.setState({
                newSelectedScopes: this.state.newSelectedScopes.filter((s) => s !== scope)
            });
        }
    }

    private handleSave = () => {
        const { previouslySelectedScopes } = this.props;
        const { newSelectedScopes } = this.state;

        const scopesToAdd = newSelectedScopes.filter(scope => !previouslySelectedScopes.includes(scope));
        const scopesToRemove = previouslySelectedScopes.filter(scope => !newSelectedScopes.includes(scope));

        this.props.onSave(scopesToAdd, scopesToRemove);
        this.props.onClose();
    };
}

export default ManageableAccess;